const _excluded = ["groupId"];function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';

import { Translate, t } from "../../../../../I18N";
import { InputField, Select } from "../../../../Components/Forms";
import { useForm } from 'react-hook-form';

import { Button, Card } from "../../../../Components/UI";
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import uniqueID from "../../../../../../shared/uniqueID";










const MenuForm = ({ closePanel, submit, link, links = [] }) => {var _link$_id3, _link$groupId, _window, _window$location;
  const [groups, setGroups] = useState([]);
  useEffect(() => {
    if (links) {
      const _groups = links.
      filter((_link) => _link.type === 'group' && _link.title).
      map((_link) => {var _link$_id, _link$_id2;return {
          label: t('Menu', _link.title, _link.title, false),
          value: (_link$_id = _link._id) === null || _link$_id === void 0 ? void 0 : _link$_id.toString(),
          key: (_link$_id2 = _link._id) === null || _link$_id2 === void 0 ? void 0 : _link$_id2.toString()
        };});
      const emptyGroup = { label: t('System', 'No Group', 'No Group', false), value: '', key: '-' };
      setGroups([emptyGroup, ..._groups]);
    }
  }, [links]);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    values: {
      title: (link === null || link === void 0 ? void 0 : link.title) || '',
      type: (link === null || link === void 0 ? void 0 : link.type) || 'link',
      url: (link === null || link === void 0 ? void 0 : link.url) || '',
      sublinks: link === null || link === void 0 ? void 0 : link.sublinks,
      _id: link === null || link === void 0 ? void 0 : (_link$_id3 = link._id) === null || _link$_id3 === void 0 ? void 0 : _link$_id3.toString(),
      groupId: link === null || link === void 0 ? void 0 : (_link$groupId = link.groupId) === null || _link$groupId === void 0 ? void 0 : _link$groupId.toString()
    },
    mode: 'onSubmit'
  });

  const updateInGroups = (groupId, linkData) => {
    let currentLinks = [...links] || [];
    if (!groupId) {
      let linkIndex = currentLinks.findIndex((_link) => _link._id === linkData._id);
      linkIndex = linkIndex === -1 ? currentLinks.length : linkIndex;
      currentLinks[linkIndex] = linkData;
    }

    if (groupId) {
      currentLinks = currentLinks.filter((_link) => _link._id !== linkData._id);

      currentLinks = currentLinks.map((_link) => {
        if (!_link.sublinks) {
          return _link;
        }

        if (_link._id !== groupId) {
          const toBeReturned = _objectSpread(_objectSpread({},
          _link), {}, {
            sublinks: _link.sublinks.filter((sublink) => sublink._id !== linkData._id) });

          return toBeReturned;
        }
        let sublinkIndex = _link.sublinks.findIndex((sublink) => sublink._id === linkData._id);
        sublinkIndex = sublinkIndex === -1 ? _link.sublinks.length : sublinkIndex;
        const sublinks = [..._link.sublinks];
        sublinks[sublinkIndex] = linkData;
        return _objectSpread(_objectSpread({}, _link), {}, { sublinks });
      });
    }

    return currentLinks;
  };

  const onSubmit = (formValues) => {
    const { groupId } = formValues,linkData = _objectWithoutProperties(formValues, _excluded);

    if (!linkData._id) {
      linkData._id = `tmp_${uniqueID()}`;
    }

    if (linkData.type === 'link') {
      delete linkData.sublinks;
    }

    const updatedLinks = updateInGroups(groupId, linkData);

    submit(updatedLinks);
  };

  const hostname = ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin) || '';

  return /*#__PURE__*/(
    _jsx("div", { className: "relative h-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "p-4 mb-4 border rounded-md shadow-sm border-gray-50 bg-primary-100 text-primary-700" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex items-center w-full gap-1 text-base font-semibold" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "w-5 h-5 text-sm" }, void 0, /*#__PURE__*/
    _jsx(CheckCircleIcon, {})
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Using URLs")
    ), /*#__PURE__*/
    _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "If it is an external URL, use a fully formed URL. Ie. http://www.uwazi.io."

    ), /*#__PURE__*/
    _jsx("br", {}), /*#__PURE__*/
    _jsx(Translate, { translationKey: "Navigation menu tool tip part 1" }, void 0, "If it is an internal URL within this website, be sure to delete the first part"

    ), ' ', "(",
    hostname, "),", ' ', /*#__PURE__*/
    _jsx(Translate, { translationKey: "Navigation menu tool tip part 2" }, void 0, "leaving only a relative URL starting with a slash character. Ie. /some_url."

    )
    )
    ), /*#__PURE__*/
    _jsx("form", { onSubmit: handleSubmit(onSubmit), id: "menu-form" }, void 0, /*#__PURE__*/
    _jsx(Card, {
      title:
      (link === null || link === void 0 ? void 0 : link.type) === 'group' ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Group") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Link") }, void 0, /*#__PURE__*/


    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "link-title",
      "data-testid": "menu-form-link-title",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Title") },
    register('title', { required: true }), {
      hasErrors: !!errors.title })
    ),
    (link === null || link === void 0 ? void 0 : link.type) === 'link' && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "link-url",
      "data-testid": "menu-form-link-url",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "URL") },
    register('url', { required: true }), {
      hasErrors: !!errors.url })
    ), /*#__PURE__*/
    React.createElement(Select, _extends({
      id: "link-group",
      "data-testid": "menu-form-link-group",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Group") },
    register('groupId'), {
      options: groups })
    )
    )

    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "absolute bottom-0 flex w-full gap-2 px-4 py-3" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      styling: "light",
      onClick: closePanel,
      className: "grow",
      "data-testid": "menu-form-cancel" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { className: "grow", type: "submit", form: "menu-form", "data-testid": "menu-form-submit" }, void 0,
    link !== null && link !== void 0 && link.title ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Update") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Add")
    )
    )
    ));

};

export { MenuForm };